import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

/**
 * OSSActionMenu
 * @param {object} actionMenuActions - Config Object of actions for each option
 * @param {array} actionMenuOptions - Available array of options for the menu
 * @param {object} anchorPosition - Required for opening and closing menu on specific row in table
 * @param {function} onClose - Method call on click outside of the menu
 * @param {boolean} open - value that opens the Menu when true
 */
const OSSActionMenu = ({
  actionMenuActions,
  actionMenuOptions,
  anchorPosition,
  onClose,
  open,
  transformOrigin = {
    vertical: "top",
    horizontal: "center"
  },
  width = 250,
  selectedTableRow,
  ...rest
}) => {
  const { state } = selectedTableRow;

  // If config has an array of enabled states, and the state matches, disable action
  // Otherwise, action will always be allowed
  const isDisabled = option => {
    return (
      option.permittedConditions && !option.permittedConditions.includes(state)
    );
  };

  return (
    <Menu
      open={open}
      onClose={onClose}
      disableAutoFocusItem
      anchorPosition={anchorPosition}
      anchorReference="anchorPosition"
      PaperProps={{
        style: {
          width
        }
      }}
      transformOrigin={transformOrigin}
      {...rest}
    >
      {actionMenuOptions.map(option => (
        <MenuItem
          disabled={isDisabled(option)}
          key={option.label}
          onClick={() => actionMenuActions(option)}
        >
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default OSSActionMenu;
